import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { toast } from 'react-toastify'
import uniqid from 'uniqid'
import _get from 'lodash.get'

import '../styles.scss'
import { apiConversation, deleteManagerAPI, categories as categoriesApi } from 'api'
import ChatComposer from './ChatComposer'
import PostDetailCard from 'components/PostDetailCard'
import ChatChannelUserInfo from './ChatChannelUserInfo'
import ChatChannelMessages from './ChatChannelMessages'
import { wallAct } from '../../../redux/actions'
import composerActions from '../../../redux/actions/conversations/composerAct'
import { openOutbound, setCurrentDataOutbound } from 'redux/outbound/actions'
import ChatChannelWallMessages from '../ChatChannelWall/ChatChannelWallMessages'
import { isToMany } from 'utils/channelsUtils'
import ModalWrapper from 'components/ModalWrapper'
import ModalDelete from 'components/ModalDelete'
import SidePopup from 'components/SidePopupNew'
import { toastMessage } from 'utils/messages'
import { USER_STATES } from '../../../constants'
import { getDeferredMessages } from 'redux/actions/conversations/messagesAct'
import { getSidePopupContent } from './utils'
import ModalVirusAttachments from 'components/common/ModalVirusAttachments'

const ChatChannels = ({ setting, getSetting }) => {
  const {
    conversations,
    brands,
    delegations,
    tabs: { activeUser, users: tabsUsers },
    companies: company,
    modules,
  } = useSelector(store => store)
  const dispatch = useDispatch()
  const [shortcuts, setShortcuts] = React.useState([])
  const [drafts, setDrafts] = React.useState([])
  const [subjects, setSubjects] = React.useState([])
  const [subjectsIsOpen, setSubjectsIsOpen] = React.useState(false)
  const [isOpenDeleteDraftModal, setIsOpenDeleteDraftModal] = React.useState(false)
  const [draftToDelete, setDraftToDelete] = React.useState('')
  const [chatmailHeader, setChatmailHeader] = React.useState({ visibleFields: ['to'] })
  const [isOpenMessageOptionsSelector, setIsOpenMessageOptionsSelector] = React.useState({})
  const [loadingSubjects, setLoadingSubjects] = React.useState({ isFirstFetching: false, isFetching: false, page: 0, limit: 100, isAll: false })
  const [isOpenContactLockedModal, setIsOpenContactLockedModal] = React.useState(false)
  const [isSubjectFiltered, setIsSubjectFiltered] = React.useState(true)
  const [removing, setRemoving] = React.useState(false)
  const [isOpenSidePopup, setIsOpenSidePopup] = useState(false)
  const [sidePopupContentType, setSidePopupContentType] = useState('')
  const [sidePopupContentData, setSidePopupContentData] = useState({})
  const [labels, setLabels] = React.useState()
  const [filterValues, setFilterValues] = React.useState({
    text: '',
    type: null,
    state: null,
    isRead: true
  })
  const conversation = conversations[activeUser]
  const provider = _get(conversation, 'user.channels.0.provider', conversation?.user?.provider_name)
  const channel = _get(conversation, 'user.channels.0.channel')
  const channelToken = _get(conversation, 'user.channels.0.token')
  const userId = conversation?.user?.id
  const isToManyUser = isToMany(company, channelToken)
  const subjectsFilterOptions = [
    { value: 'drafts', label: 'Borradores' },
    { value: 'scheduled', label: 'Programados' },
    { value: 'sent', label: 'Enviados' },
    { value: 'received', label: 'Recibidos' }
  ]
  const statesOptions = USER_STATES['top'].map((state) => ({
    value: state,
    label: I18n.t(`states_${state}`)
  }))
  const activitiesTypes = [
    'category',
    'category_removed',
    'list_add',
    'list_removed',
    'assigned_add',
    'assigned_removed',
    'status_changed',
    'center_changed',
    'act_payment_create',
    'act_payment_renew',
    'act_payment_cancel',
    'act_payment_refund',
    'act_customer_url_visited',
    'act_read',
    'act_unread',
    'act_mnemonic_removed',
    'act_exported'
  ]

  React.useEffect(() => {
    const draftId = conversation?.composer?.draftToEdit

    if (provider === 'chatmail' && drafts.length && draftId) {
      const draft = drafts.filter(draft => draft._id === draftId)[0]

      if (draft) {
        const { to, cc, cco, users } = draft
        getChatmailHeader({ to, cc, cco, users })
      }
    }
  }, [drafts])

  React.useEffect(() => {
    if (userId && provider === 'chatmail') getSubjects({ userId })
  }, [userId, filterValues.text, filterValues.type, filterValues.state, filterValues.isRead])

  React.useEffect(() => {
    if (userId) {
      dispatch(getDeferredMessages())

      if (conversation.user.withDrafts) {
        getDrafts({ userId: conversation.user._id })
      }

      if (conversation?.user?.channels?.[0]?.channel.includes('_post')) {
        getLabels()
      }
    }

    return () => {
      setSubjects([])
      setSubjectsIsOpen(false)
      setFilterValues({
        text: '',
        type: null,
        state: null,
        isRead: true
      })
      setDrafts([])
      setLoadingSubjects({ isFirstFetching: false, isFetching: false, page: 0, limit: 100, isAll: false })
      setIsSubjectFiltered(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  React.useEffect(() => {
    initForChatmail()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversation?.composer?.currentSubject])

  React.useEffect(() => {
    initForChatmail('chat')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subjects, conversation?.chat?.messages])

  React.useEffect(() => {
    if (setting.shortCuts) {
      const shortCutList = setting.shortCuts.reduce((preV, short) => {
        const { keyboardShortcut, answerList, category: _category } = short

        const answer = _get(answerList, '0.es.content')
        const answerHtml = _get(answerList, '0.es.contentHtml')
        const attachments = _get(answerList, '0.es.attachments')
        const buttons = _get(answerList, '0.es.buttons')
        const category = _category === 'none' ? I18n.t('dashboard_general') : _category

        if (answer) {
          preV.push({ keyboardShortcut, answer, answerHtml, attachments, buttons, category })
        }

        return preV
      }, [])

      setShortcuts(shortCutList)
    } else {
      setShortcuts([])
    }
  }, [setting.shortCuts])

  const initForChatmail = (from) => {
    // Carga inicial de campos para el ChatMail según el ultimo mensaje
    if (subjects.length && conversation.chat.messages.length && isSubjectFiltered) {
      let messageData = {}

      conversation.chat.messages.forEach(message => {
        if (Object.keys(messageData).length) return
        if (
          !['customer', 'operator', 'smartchat', 'bot', 'channel_corporate'].includes(message.type)
          && conversation.chat.messages.some(message => message.messageId)
        ) return
        if (!message.subject || !message.subjectId) return
        if (
          conversation.composer.messageId
          && conversation.composer.messageId !== message.messageId
        ) return

        messageData = message
      })

      if (Object.keys(messageData).length) {
        const { channelToken } = conversation.user
        const { type: messageType, from, to = [], cc = [], cco = [] } = messageData

        const toRight = to.filter(u => u.email !== channelToken)
        const ccRight = cc.filter(u => u.email !== channelToken)
        const ccoRight = cco.filter(u => u.email !== channelToken)
        const fromRight = from && from !== channelToken ? [{ email: from }] : []

        const chatmailHeader = getChatmailHeader({
          to: messageType === 'customer'
            ? [...fromRight, ...toRight]
            : toRight,
          cc: ccRight,
          cco: ccoRight,
          returnValue: true
        })

        setChatmailHeader(prevState => ({ ...prevState, ...chatmailHeader }))
      } else {
        setChatmailHeader({ visibleFields: ['to'] })
      }

      if (from === 'chat' && !conversation.composer.currentSubject?._id) {
        dispatch(composerActions.setCurrentSubject({
          _id: messageData.subjectId,
          name: messageData.subject
        }))
      }
    }
  }

  const toggleContactLockedModal = () => setIsOpenContactLockedModal(!isOpenContactLockedModal)

  const toggleDeleteDraftModal = ({ draftId }) => {
    if (draftId) {
      setDraftToDelete(draftId)
    } else {
      setDraftToDelete('')
    }

    setIsOpenDeleteDraftModal(!isOpenDeleteDraftModal)
  }

  const toggleMessageOptionsSelector = ({ id }) => {
    if (id) {
      setIsOpenMessageOptionsSelector(prevState => ({ ...prevState, [id]: !prevState[id] }))
    } else {
      setIsOpenMessageOptionsSelector({})
    }
  }

  const getChatmailHeader = ({ to, cc, cco, users, returnValue }) => {
    const visibleFields = ['to']

    const toChipsValues = []
    if (to?.length) {
      to.forEach(contact => {
        if (users) {
          const user = users.filter(user => user.id === contact.id)[0]
          if (user) toChipsValues.push({
            id: uniqid(),
            value: user.email,
            isValid: true
          })
        } else {
          toChipsValues.push({
            id: uniqid(),
            value: contact.email,
            isValid: true
          })
        }
      })
    }

    const ccChipsValues = []
    if (cc?.length) {
      cc.forEach(contact => {
        if (users) {
          const user = users.filter(user => user.id === contact.id)[0]
          if (user) {
            ccChipsValues.push({
              id: uniqid(),
              value: user.email,
              isValid: true
            })
            visibleFields.push('cc')
          }
        } else {
          ccChipsValues.push({
            id: uniqid(),
            value: contact.email,
            isValid: true
          })
          visibleFields.push('cc')
        }
      })
    }

    const ccoChipsValues = []
    if (cco?.length) {
      cco.forEach(contact => {
        if (users) {
          const user = users.filter(user => user.id === contact.id)[0]
          if (user) {
            ccoChipsValues.push({
              id: uniqid(),
              value: user.email,
              isValid: true
            })
            visibleFields.push('cco')
          }
        } else {
          ccoChipsValues.push({
            id: uniqid(),
            value: contact.email,
            isValid: true
          })
          visibleFields.push('cco')
        }
      })
    }

    if (returnValue) {
      return {
        to: {
          chips: toChipsValues,
          input: ''
        },
        cc: {
          chips: ccChipsValues,
          input: ''
        },
        cco: {
          chips: ccoChipsValues,
          input: ''
        },
        visibleFields
      }
    }

    setChatmailHeader(prevState => ({
      ...prevState,
      to: {
        chips: toChipsValues,
        input: ''
      },
      cc: {
        chips: ccChipsValues,
        input: ''
      },
      cco: {
        chips: ccoChipsValues,
        input: ''
      },
      visibleFields
    }))
  }

  const getOutboundData = async ({ channel, brand, delegation, deliveryChannel, to, cc, cco, subject, visibleFields, message }) => {
    let deliveryChannelData = ''
    if (deliveryChannel?.channel) {
      const { data } = await apiConversation.conversations.getChannelsOPTOUT({ type: channel })
      deliveryChannelData = {
        value: deliveryChannel.channel,
        label: data.find(channel => channel.id === deliveryChannel.channel).value
      }
    }

    return {
      channel,
      brand: brand ? [{ value: brand, label: brands[brand].name }] : [],
      delegation: delegation ? [{ value: delegation, label: delegations[delegation].name }] : [],
      deliveryChannel: {
        channel: deliveryChannelData,
        assignToMe: deliveryChannel?.assignToMe ? deliveryChannel.assignToMe : false,
        isBlockedAssignToMe: deliveryChannel?.isBlockedAssignToMe ? deliveryChannel.isBlockedAssignToMe : false
      },
      deliveryChannelOptions: null,
      to: to ? to : { chips: [], input: '' },
      cc: cc ? cc : { chips: [], input: '' },
      cco: cco ? cco : { chips: [], input: '' },
      template: [],
      subject: subject ? subject : '',
      message: message ? message : {},
      visibleFields: visibleFields ? visibleFields : ['to']
    }
  }

  const getDrafts = (data) => {
    apiConversation.conversations.getDrafts(data)
      .then(({ data }) => setDrafts(data))
  }

  const handleEditDraft = async ({ draftId }) => {
    const draft = drafts.filter(draft => draft._id === draftId)[0]

    if (draft) {
      const { type, _id, provider, to, cc, cco, users, subject, subjectId, message } = draft

      if (type === 'chat') {
        // Draft to edit
        dispatch(composerActions.setDraftToEdit(_id))

        // Chatmail header
        if (provider === 'chatmail') getChatmailHeader({ to, cc, cco, users })

        // Subject
        dispatch(composerActions.setCurrentSubject({ _id: subjectId, name: subject }))

        // Message
        dispatch(composerActions.addExternalText(message.content))

        // Attachments
        dispatch(composerActions.setFiles(message.attachments))

        // Buttons
        dispatch(composerActions.updateButtons(message.buttons))
      }
    }
  }

  const handleDeleteDraft = ({ draftId }) => {
    setRemoving(true)

    apiConversation.conversations.deleteDraft({ draftId })
      .then(response => {
        if (response.status === 200) {
          const newDrafts = [...drafts]
          const draftIndex = drafts.findIndex(draft => draft._id === draftId)
          newDrafts.splice(draftIndex, 1)
          setDrafts(newDrafts)
          setRemoving(false)
          toggleDeleteDraftModal({})
          toastMessage(I18n.t('draft_successful_delete'))
        }
      })
      .catch(() => {
        setRemoving(false)
        toastMessage(I18n.t('draft_error_delete'), 'error')
      })
  }

  const handleToggleShowHideDraft = ({ draftId }) => {
    const draft = drafts.filter(draft => draft._id === draftId)[0]

    const data = {
      ...draft,
      isPrivate: !draft.isPrivate
    }

    apiConversation.conversations.updateDraft({ draftId, data })
      .then(response => {
        if (response.status === 200) {
          const draftIndex = drafts.findIndex(draft => draft._id === draftId)
          const newDrafts = Object.assign([...drafts], {
            [draftIndex]: {
              ...drafts[draftIndex],
              isPrivate: !draft.isPrivate
            }
          })
          setDrafts(newDrafts)
          toastMessage(I18n.t('draft_successful_update'))
        }
      })
      .catch(() => toastMessage(I18n.t('draft_error_update'), 'error'))
  }

  const handleMessageOption = async ({ type, messageId, content={} }) => {
    const message = conversation.chat.messages.filter(message => message.messageId === messageId)[0]

    if (message) {
      const { channelToken } = conversation.user
      const { type: messageType, from, to = [], cc = [], cco = [], subject, subjectId, text, buttons, attachments } = message

      const toRight = to.filter(u => u.email !== channelToken)
      const ccRight = cc.filter(u => u.email !== channelToken)
      const ccoRight = cco.filter(u => u.email !== channelToken)
      const fromRight = from && from !== channelToken ? [{ email: from }] : []

      if (type === 'reply' || type === 'replyAll') {
        // Message to reply
        dispatch(composerActions.setReplyMessage(messageId))
        const isCustomerMsg = messageType === 'customer'

        const toReply = isCustomerMsg
          ? fromRight
          : toRight

        const chatmailHeader = getChatmailHeader({
          to: type === 'reply' ? toReply : isCustomerMsg ? toReply.concat(toRight) : toReply,
          cc: type === 'reply' ? [] : ccRight,
          cco: type === 'reply' ? [] : ccoRight,
          returnValue: true
        })

        setChatmailHeader({
          ...chatmailHeader,
          visibleFields: chatmailHeader.visibleFields
        })

        dispatch(composerActions.setCurrentSubject({ _id: subjectId, name: subject }))

        toggleMessageOptionsSelector({})

        return true
      }

      if (type === 'resend') {
        const chatmailHeader = getChatmailHeader({
          to: messageType === 'customer'
            ? [...fromRight, ...toRight]
            : toRight,
          cc: ccRight,
          cco: ccoRight,
          returnValue: true
        })

        const outboundData = await getOutboundData({
          ...chatmailHeader,
          channel: provider,
          subject,
          message: {
            content: text,
            buttons,
            attachments
          }
        })

        dispatch(setCurrentDataOutbound({ outboundCurrentData: outboundData }))
      }

      if (type === 'delete')
        deleteMessage({ provider, content })

      toggleMessageOptionsSelector({})
    }
  }

  const deleteMessage = async ({ provider, content }) => {
    try{
      const data = {
        userId,
        messageId : content._id
      }
      if(provider === 'chatmail') data.subjectId = content.subjectId
      await deleteManagerAPI.deleteMessage(data)
    }catch(error){
      toast(I18n.t('error_message_delete'), { position: 'top-right' })
    }

  }

  const getSubjects = async ({ userId }) => {
    if (loadingSubjects.isFirstFetching) {
      setLoadingSubjects(prevState => ({
        ...prevState,
        isFetching: true
      }))
    }

    let params = {
      page: loadingSubjects.page,
      limit: loadingSubjects.limit,
      text: filterValues.text || ''
    }
    if (filterValues.type?.value) params.selectType = filterValues.type.value
    if (filterValues.state?.value) params.state = filterValues.state.value
    if (!filterValues.isRead) params.isRead = filterValues.isRead

    try {
      const { data } = await apiConversation.conversations.getSubjects({ userId, params })
      const subjects = []
      for (const subject of data) {
        if(!subject.isRemoved) subjects.push(subject)
      }
      if (filterValues.text) {
        setSubjects(subjects)
      } else {
        setSubjects(prevState => ([...prevState, ...subjects]))
      }

      setLoadingSubjects(prevState => ({
        ...prevState,
        page: data.length >= 100 ? prevState.page + 1 : prevState.page,
        limit: 100,
        isAll: data.length < 100 ? true : false,
        isFirstFetching: true,
        isFetching: false
      }))
    } catch (error) {
      setLoadingSubjects(prevState => ({
        ...prevState,
        isFirstFetching: true,
        isFetching: false
      }))
      console.error(error)
    }
  }

  const handleDeleteSubject = async (data) => {
    try {
      const response = await deleteManagerAPI.deleteSubject(data)
      if (response.data?.success) getSubjects({ userId: data.userId })
    } catch(error) {
      toast(I18n.t('error_message_delete'), { position: 'top-right' })
    }
  }

  const getLabels = () => {
    const brands = [conversation.user.brand]
    const delegations = [conversation.user.delegation]
    categoriesApi.records.search(brands, delegations)
      .then(({ data }) => setLabels(data))
      .catch(error => console.error(error))
  }

  const toggleSidePopup = (params = {}) => {
    const { contentType, contentData } = params
    setIsOpenSidePopup(prevState => !prevState)
    setSidePopupContentType(contentType || '')
    setSidePopupContentData(contentData || {})
  }

  if (!conversation || !tabsUsers || tabsUsers.length < 1) return null

  return (
    <div className='conversation'>
      <div className='conversation__header'>
        <ChatChannelUserInfo
          user={conversation.user}
          chat={conversation.chat}
          isToManyUser={isToManyUser}
          getSetting={getSetting}
          setting={setting}
        />
        <ChatComposer
          chat={conversation.chat}
          composer={conversation.composer}
          userId={provider === 'wall' ? conversation.user._id : conversation.user.id}
          conversationUser={conversation.user}
          shortcuts={shortcuts}
          isVirtualAssistantActive={!!(setting.isVirtualAssistantActive && modules.faqConsoleAssistant.isActive)}
          getSubjects={getSubjects}
          loadingSubjects={loadingSubjects}
          filterValues={filterValues}
          setFilterValues={setFilterValues}
          subjects={subjects}
          setSubjects={setSubjects}
          subjectsIsOpen={subjectsIsOpen}
          setSubjectsIsOpen={setSubjectsIsOpen}
          chatmailHeader={chatmailHeader}
          setChatmailHeader={setChatmailHeader}
          subjectsFilterOptions={subjectsFilterOptions}
          setIsSubjectFiltered={setIsSubjectFiltered}
          toggleContactLockedModal={toggleContactLockedModal}
          statesOptions={statesOptions}
          handleDeleteSubject={handleDeleteSubject}
        />
      </div>
      {['instagram_post', 'facebook_post'].includes(channel) && (
        <PostDetailCard
          key={conversation.user.id}
          avatarSrc={conversation.user.avatarUrl}
          photos={conversation.user.photos}
          contentText={conversation.user.description}
          postLink={conversation.user.postLink}
          avatarMime={conversation.user.avatarMime}
          channel={conversation.user?.channels?.[0]?.channel}
          reactions={conversation.user.channels[0].channel === 'instagram_post'
            ? conversation.user.likeCount ? [{ totalCount: conversation.user.likeCount, typeReaction: 'LOVE' }] : [{ totalCount: 0, typeReaction: 'LOVE' }]
            : conversation.user.reactionsFB?.length ? conversation.user.reactionsFB : [{ totalCount: 0, typeReaction: 'LIKE' }]
          }
        />
      )}
      {provider === 'wall' ? (
        <ChatChannelWallMessages
          key={conversation.user._id}
          chat={{ ...conversation.chat, drafts }}
          user={conversation.user}
          labels={labels}
          activitiesTypes={activitiesTypes}
          getWall={params => dispatch(wallAct.getWall(params))}
          toggleDeleteDraftModal={toggleDeleteDraftModal}
          handleEditDraft={handleEditDraft}
          handleToggleShowHideDraft={handleToggleShowHideDraft}
        />
      ) : (
        <ChatChannelMessages
          composer={conversation.composer}
          chat={{ ...conversation.chat, drafts }}
          user={conversation.user}
          activitiesTypes={activitiesTypes}
          isOpenMessageOptionsSelector={isOpenMessageOptionsSelector}
          toggleMessageOptionsSelector={toggleMessageOptionsSelector}
          toggleDeleteDraftModal={toggleDeleteDraftModal}
          handleEditDraft={handleEditDraft}
          handleToggleShowHideDraft={handleToggleShowHideDraft}
          handleMessageOption={handleMessageOption}
          toggleSidePopup={toggleSidePopup}
        />
      )}

      <ModalWrapper
        contentClassName='conversation__subject-info-modal'
        isOpen={isOpenContactLockedModal}
        toggle={toggleContactLockedModal}
        body={<p dangerouslySetInnerHTML={{ __html: I18n.t('chatmail_subject_info_contact') }}></p>}
        eventBtnTxt={I18n.t('btn_write')}
        eventBtn={() => {
          dispatch(openOutbound({ channel: 'chatmail' }))
          toggleContactLockedModal()
        }}
        cancelBtnTxt={I18n.t('dashboard_close')}
        cancelBtn={toggleContactLockedModal}
      />

      <ModalDelete
        isOpen={isOpenDeleteDraftModal}
        toggle={() => toggleDeleteDraftModal({})}
        header={I18n.t('conversations_remove_draft')}
        text1={I18n.t('conversations_remove_draft_title')}
        text2={I18n.t('dashboard_action-cannot-reversed')}
        event={() => handleDeleteDraft({ draftId: draftToDelete })}
        isSubmitting={removing}
      />

      {conversation?.composer?.files.length
        ? <ModalVirusAttachments attachments={[...conversation.composer.files]} />
        : null
      }

      {isOpenSidePopup ? (
        <SidePopup onHide={toggleSidePopup} className='conversation__side-popup'>
          {getSidePopupContent({ type: sidePopupContentType, data: sidePopupContentData, toggle: toggleSidePopup })}
        </SidePopup>
      ) : null}
    </div>
  )
}

export default ChatChannels
